import React, { PropsWithChildren } from 'react';
import { Spinner } from 'react-bootstrap';

import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import ClienteNaoPublicado from 'components/Relatorios/shared/Aprovacao/ClienteNaoPublicado';
import useRelatorioAprovacao from 'hooks/Relatorios/Aprovacao/useRelatorioAprovacao';

/**
 * Gate fail-closed (Q5) em volta do `Outlet` das seções do informe: flag off ou
 * admin → children direto; loading → spinner; erro → `QueryErrorState`
 * (nunca vaza a seção); publicado → children; senão `ClienteNaoPublicado`.
 */
export default function PublicacaoGate({ children }: PropsWithChildren) {
  const {
    habilitado, isAdmin, isLoading, isError, refetch, publicado,
  } = useRelatorioAprovacao();

  // children é ReactNode; o fragment garante um JSX.Element válido para o TypeScript.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!habilitado || isAdmin) return <>{children}</>;

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (isError) {
    return (
      <QueryErrorState
        title="Não foi possível verificar a publicação do informe"
        onRetry={refetch}
      />
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment -- ver comentário acima.
  if (publicado) return <>{children}</>;

  return <ClienteNaoPublicado />;
}
